<ng-container *ngIf="phase != null">
    <div class="barra">
        <options class="show-label" [optionstrip]="options" (clickOption)="clickOption($event)"></options>
        <shared-route-ecmr-actions [phaseId]="phase.phaseId" [agent]="agent" (actionExecuted)="onActionExecuted()"></shared-route-ecmr-actions>
    </div>
    <shared-sign *ngIf="uuid && agent && optionSelected != 'QR'" [uuid]="uuid" [agent]="agent"
        (signedChanged)="onSignedChanged()" [defaultSign]="defaultSign" [contract]="contract"></shared-sign>
    <shared-phase-cmr-qr-component *ngIf="optionSelected == 'QR'" [phaseUUID]="uuid" [helpResource]="'SHARED.QR.CMR.HELP'"></shared-phase-cmr-qr-component>
</ng-container>